<lib-header *ngIf="showShell" [logoSrc]="'favicon.png'" [brandName]="brandName" [contactEmail]="contactEmail" [contactPhone]="contactPhone"
  [navLinks]="navLinks"></lib-header>

<router-outlet></router-outlet>

<lib-footer *ngIf="showShell" [contactTitle]="contactTitle" [address]="address" [email]="contactEmail" [phone]="contactPhone"
  [col2Title]="col2Title" [col2Links]="quickLinks" [col3Title]="col3Title" [col3Links]="popularLinks"
  [newsletterTitle]="newsletterTitle" [newsletterSubtitle]="newsletterSubtitle" [newsletterButton]="newsletterButton"
  [newsletterPlaceholder]="newsletterPlaceholder" [copyrightText]="brandName" [showPrivacyPolicy]="false"></lib-footer>

<!-- Back to Top -->
<a *ngIf="showShell" href="#" class="btn btn-dark py-3 fs-4 back-to-top"><i class="bi bi-arrow-up"></i></a>
